import { useCountdown } from '../hooks/useTimers';

interface CountdownProps {
  target: string;
  variant?: 'light' | 'dark';
  label?: string;
}

/** Countdown in four blocks: days, hours, minutes and seconds. */
export function Countdown({
  target,
  variant = 'light',
  label = 'Começa em',
}: CountdownProps) {
  const { d, h, m, s } = useCountdown(target);
  const units: Array<[string, string]> = [
    [d, 'Dias'],
    [h, 'Horas'],
    [m, 'Min'],
    [s, 'Seg'],
  ];

  return (
    <div
      className={`pv-countdown pv-countdown--${variant}`}
      role="timer"
      aria-label={`${label} ${Number(d)} dias, ${Number(h)} horas e ${Number(m)} minutos`}
    >
      {units.map(([value, unit]) => (
        <div className="pv-countdown__cell" key={unit} aria-hidden="true">
          <div className="pv-countdown__value">{value}</div>
          <div className="pv-countdown__unit">{unit}</div>
        </div>
      ))}
    </div>
  );
}
